import { PageModal } from './AccountModal'
import { Bubble } from './AccountKidsProfileBrand'
import { AccountSectionWrapper, ANCHOR_TAGS, Separator } from './AccountSectionWrapper'
import { useToggle } from '../hooks/useToggle'
import { FormAddSport } from './FormAddSport'
import { sportOptions } from '../helpers/GlobalAssets'
import { accountTranslations } from '../helpers/translations'

export const AccountKidsProfileSports = ({ profile, connectionId, handleRefetch }) => {
  const { isActive, handleToggle } = useToggle(false)
  const selectedSports = profile?.custom_attributes?.omneo?.sports ?? []

  return (
    <AccountSectionWrapper
      anchorTag={ANCHOR_TAGS.FAVOURITE_SPORTS.tag}
      title={accountTranslations.kids_profiles.favourite_sports.title}
      cta={{
        title: accountTranslations.kids_profiles.favourite_sports.cta,
        icon: 'plus',
        callback: handleToggle
      }}
      showDivider={false}
    >
      <PageModal
        props={{
          isActive,
          handleToggle,
          modalTitle: accountTranslations.kids_profiles.favourite_sports.update_cta,
          modal: (
            <FormAddSport
              sports={sportOptions}
              selectedSports={selectedSports}
              connectionId={connectionId}
              handleToggle={handleToggle}
              handleRefetch={handleRefetch}
            />
          )
        }}
      >
        <div class="flex flex-row flex-wrap gap-4 py-4">
          {selectedSports.map((sportValue) => {
            const sportData = sportOptions.find((s) => s.value === sportValue)
            if (!sportData) return null
            return (
              <Bubble>
                <div className={'aspect-1 max-h-8 w-16'}>
                  <img src={sportData.icon} className={'h-full w-full object-contain'} />
                </div>
                <div>{sportData.label}</div>
              </Bubble>
            )
          })}
        </div>
        <Separator />
      </PageModal>
    </AccountSectionWrapper>
  )
}
